// extracted by css-extract-rspack-plugin
export default {"container":"container-sbPx1E","content":"content-k9kmbb","receiptsList":"receiptsList-HVYwnQ","backButton":"backButton-xy4OTP","footer":"footer-AV2XgL","buttons":"buttons-Z82ZNS"};